// extracted by mini-css-extract-plugin
module.exports =  {"container":"_373a3719ba--container--NC5Zm","title":"_373a3719ba--title--K_S25","description":"_373a3719ba--description--LkRdI","security":"_373a3719ba--security--CTawT"};